/* eslint-disable import/no-unresolved */
import { useMemo } from 'react';

import { getTotalTradingEquity } from 'components/primaryHeader/partials/walletMenu/computeTotalBalance';
import { cropAfterDecimals, sortBalancesBySortPriority } from 'helpers';
import {
  allOpenPositionsSelector,
  enableWalletsSelector,
  openPositionMarkPriceSelectorById,
  portfolioMarginSelector,
  walletSpotPriceBySymbol,
} from 'selectors';
import { useAppSelector } from 'storeHooks';

const useTotalEquity = (): string | number => {
  const balance = useAppSelector(enableWalletsSelector);
  const balancesArray = sortBalancesBySortPriority(balance);

  const openPositions = useAppSelector(allOpenPositionsSelector);
  const portfolioMarginData = portfolioMarginSelector();
  const { positions_upl: positionsUPL, asset_id: portfolioEnabledAsset } =
    portfolioMarginData?.aggregate || {};

  const totalTradingEquity = useMemo(() => {
    return getTotalTradingEquity(
      balancesArray,
      openPositions,
      openPositionMarkPriceSelectorById,
      walletSpotPriceBySymbol,
      positionsUPL,
      portfolioEnabledAsset
    );
  }, [balancesArray, openPositions, portfolioEnabledAsset, positionsUPL]);
  const totalEquityInUsd = cropAfterDecimals(Number(totalTradingEquity), 2);

  if (!Object.keys(balance).length) return '-';

  return totalEquityInUsd;
};

export default useTotalEquity;
